module.exports = __webpack_public_path__ + "static/BannerAmenities2x-375bd1158a93d9411417498f25b7424a.jpg";